module.exports = __webpack_public_path__ + "img/home.e4c80773.png";